import React from 'react'
import LineItem from './LineItem'

export default class Cart extends React.Component {
  render() {
    return (
      <div>
        <LineItem
          title={'Applied Business Computing Concepts'}
          amount={'$69.99'}
          bold={false}
        />
        <hr className="w-25" />
        <LineItem title={'Subtotal'} amount={'$69.99'} bold={false} />
        <LineItem
          className="mb-5"
          title={'Total Charged'}
          amount={'$69.99'}
          bold
        />
        <hr className="mt-5 w-75 border-dark" />
        <div className="text-center">
          <a className="text-dec-none" href="#">
            <h5>Enter an access code.</h5>
          </a>
        </div>
      </div>
    )
  }
}
